import React from 'react';

import './category-collections.style.css';

const categoryCollections = ({image_url,name}) => (

    <div className='uk-flex uk-flex-left ' >
        

        <div id="spynavcontainer" className="category-collections-container">
            <div className='shrink uk-box-shadow-small uk-text-center category-collections-img-container' >
                <img className="category-collections-img" src={image_url} alt='thali' />
            </div>
            <div className="names uk-text-center  category-collections-name-container">
                <p className=' uk-margin-remove uk-text-center category-collections-name' >{name}</p>
            </div>


        </div>

    </div>
)

export default categoryCollections;